import { Configuration, PublicClientApplication, RedirectRequest } from '@azure/msal-browser';

import env from '@config/runtimeConfig';

const authEnv = env === 'local' ? 'dev' : env;

const clientId = '84f05ba9-5145-4319-9704-0a05265b4b36';

const msalConfig: Configuration = {
  auth: {
    authority: 'https://login.microsoftonline.com/lyse.onmicrosoft.com',
    clientId,
    redirectUri: window.location.origin,
  },
};

const scopes = [`api://ats-${authEnv}/access_as_user`, 'profile'];

const loginRequest: RedirectRequest = { scopes };

const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance, loginRequest, scopes };
